import { inject, Injectable } from '@angular/core';
import { HttpService } from '@services/http.service';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RelationCheckService {
  private http = inject(HttpService);
  private readonly periodApi = `${environment.portageUrl}/relations/check`;

  checkRelation(
    parent_id: number,
    child_id: number,
    relation_type: 'guest_in_household' | 'period-in-guest'
  ): Observable<any> {
    return this.http.post(this.periodApi, {
      parent_id,
      child_id,
      relation_type,
    });
  }
}
